import { createMachine } from "xstate";
import { fetchOrchestrators } from "@nju/data-access-portal-orchestrator";

export enum events {
  ERROR = "ERROR",
  NEW_ORDER = "NEW_ORDER",
  NEW_ORDER_SUCCESS = "NEW_ORDER_SUCCESS",
  ANOTHER_ORDER_IN_PROGRESS = "ANOTHER_ORDER_IN_PROGRESS",
}

type IEvent =
  | { type: events.ERROR }
  | { type: events.NEW_ORDER }
  | { type: events.NEW_ORDER_SUCCESS }
  | { type: events.ANOTHER_ORDER_IN_PROGRESS };

export const mobileDashboardMainPage = createMachine(
  {
    schema: {
      events: {} as IEvent,
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          [events.NEW_ORDER]: {
            target: "newOrder",
          },
        },
      },
      newOrder: {
        invoke: {
          src: "newOrder",
        },
        on: {
          [events.NEW_ORDER_SUCCESS]: {
            actions: "onNewOrderSuccess",
            target: "finish",
          },
          [events.ANOTHER_ORDER_IN_PROGRESS]: {
            actions: "onAnotherOrderInProgress",
            target: "finish",
          },
          [events.ERROR]: {
            target: "error",
          },
        },
      },
      error: {
        type: "final",
      },
      finish: {
        type: "final",
      },
    },
  },
  {
    services: {
      newOrder: () => {
        return async (callback) => {
          try {
            const { multiOrder, ftth } = (await fetchOrchestrators()).unwrap();

            if (
              (multiOrder && multiOrder.state !== "START") ||
              (ftth && ftth.orderStatus === "Draft")
            ) {
              return callback({ type: events.ANOTHER_ORDER_IN_PROGRESS });
            }

            return callback({ type: events.NEW_ORDER_SUCCESS });
          } catch {
            return callback({ type: events.ERROR });
          }
        };
      },
    },
  },
);
